import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CustomInput from "../CustomInput";
import Notification from "../ui-elements/Notification";
import {
  createUser,
  deleteUser,
  deleteUserImage,
  updateUser,
  uploadUserImage,
} from "../../services/users";
import { IS_LOCAL_ENV } from "../../App";
import ModalStructure from "../ModalStructure";

const options = [
  { text: "Admin", value: "SuperAdmin" },
  { text: "Editor de tienda", value: "StoreEditor" },
  { text: "Editor de ambiente", value: "EcosystemEditor" },
];

const UserCard = ({ info, handleClose, loadToParent, removeFromParent }) => {
  const user = useSelector((state) => state.auth.user);
  const [localInfo, setLocalInfo] = useState({
    name: info?.name || "",
    email: info?.email || "",
    role: info?.role || "",
    profileImage: info?.profileImage || null,
  });

  const [password, setPassword] = useState("");
  const [imgFile, setImgFile] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [uploading, setUploading] = useState(false);
  const [cardId] = useState(Date.now()); // Identificador único para cada card
  const [showEditPassword, setShowEditPassword] = useState(info ? false : true); //se muestra en creacion o marcando un checbox de update password
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    if (imgFile) {
      const objectUrl = URL.createObjectURL(imgFile); // Genera una URL para el archivo seleccionado
      setPreviewImage(objectUrl);

      return () => URL.revokeObjectURL(objectUrl); // Limpia la URL al desmontar el componente
    }
  }, [imgFile]);

  const onChangeSomeValue = (prop, newValue) => {
    setLocalInfo({ ...localInfo, [prop]: newValue });
  };

  const handleFileChange = (e, type) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.type.startsWith("image/") && type === "mainImage") {
        setImgFile(selectedFile);
      } else {
        Notification({
          title: "Operación inválida",
          text: "Por favor selecciona una imagen válida.",
          type: "Error",
        });
      }
    }
  };

  const validData = () => {
    return (
      localInfo.name.trim() !== "" &&
      localInfo.email.trim() !== "" &&
      localInfo.role.trim() !== "" &&
      (setShowEditPassword == true ? password.trim() !== "" : true)
    );
  };

  const handleSubmit = async (e) => {
    setUploading(true);
    e.preventDefault();
    if (!validData()) {
      Notification({
        title: "Error",
        text: "Datos incompletos",
        type: "Error",
      });
      setUploading(false);
      return;
    }
    const uploadData = async () => {
      try {
        let data = { ...localInfo }; //copia del estado ya que se realizaran cambios
        delete data.profileImage; //no necesitamos enviar la imagen de perfil, solo si se carga una nueva

        //subir imagen de perfil en caso exista
        let newProfileImage = null;
        if (imgFile != null) {
          //eliminar imagen anterior
          if (info?.profileImage) await deleteUserImage(info.profileImage.id);
          //subir imagen
          newProfileImage = await uploadUserImage({
            file: imgFile,
            alt: "perfil",
          });
        }

        //============actualizar o crear producto=============
        //si se cambio la foto de perfil, se actualiza
        if (newProfileImage != null) data["profileImage"] = newProfileImage.id;
        //se no se cambio la foto, no se envia profileImage

        //si se cambio la contraseña, se actualiza
        if (setShowEditPassword) data.password = password;
        IS_LOCAL_ENV && console.log(data);
        const newObj = info
          ? await updateUser(info.id, data)
          : await createUser(data);
        IS_LOCAL_ENV && console.log("usuario actualizado o creado: ", newObj);
        //setLocalInfo({name: newObj.name, email: newObj.email, role: newObj.role});
        Notification({
          title: "Operación completada",
          text: `Se ${info ? "actualizó" : "creó"} el perfil del usuario`,
          type: "Success",
        });
        info && loadToParent(newObj, newObj.id);
        !info && loadToParent(newObj);
        !info && handleClose();
        setUploading(false);
      } catch (err) {
        setUploading(false);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };

    uploadData();
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    setUploading(true);
    const deleteData = async () => {
      try {
        //eliminar imagen anterior
        if (info?.profileImage) await deleteUserImage(info.profileImage.id);

        const { data } = await deleteUser(id);
        Notification({
          title: "Operación completada",
          text: `Se ${info ? "eliminó" : "eliminó"} el usuario`,
          type: "Success",
        });
        setUploading(false);
        removeFromParent(info.id);
      } catch (err) {
        setUploading(false);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };

    deleteData();
  };

  return (
    <div
      className={`flex flex-col gap-2 items-center  ${
        info && "border-accent-green border-[1px]"
      } rounded-xl p-2 md:p-4 w-fit h-fit bg-white`}
    >
      <div className="max-w-[620px]  flex flex-wrap w-fit  gap-2 justify-center">
        <div className="w-fit flex flex-col gap-2 items-center">
          <img
            src={
              previewImage || // URL de vista previa si se seleccionó un archivo
              (info?.profileImage
                ? process.env.REACT_APP_SERVER + info?.profileImage?.url // Imagen de respaldo si existe
                : "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png") // Imagen predeterminada
            }
            alt="Perfil"
            className="rounded-full w-[200px] h-[200px] border-[1px] object-cover"
          />
          {!info && (
            <label
              htmlFor={`profile-image-input-${cardId}`}
              className="hover:text-blue-500 hover:underline text-dark-green py-2 px-4 text-base w-fit cursor-pointer font-poppins"
            >
              {/* info ? "Cambiar Imagen" : */ "Agregar Imagen"}
            </label>
          )}
          <input
            id={`profile-image-input-${cardId}`}
            className="hidden"
            type="file"
            accept="image/*"
            onChange={(e) => handleFileChange(e, "mainImage")}
            disabled={!!info}
          />
        </div>
        <div className="flex flex-col gap-2 items-center">
          <ul>
            {["name", "email", "role"].map((prop, i) => {
              return prop === "role" ? (
                <CustomInput
                  key={i}
                  title={"Rol"}
                  inputType={"select"}
                  selectProps={{
                    disabled: !!info, // info?.role === "SuperAdmin",
                    options: options,
                    placeholder: "Seleccionar rol",
                    isInputChild: true,
                    initialValue: info?.[prop] || "",
                    customW: "w-full",
                    setValue: (e) => onChangeSomeValue("role", e.target.value),
                  }}
                />
              ) : (
                <li key={i} className="flex flex-wrap">
                  <CustomInput
                    disabled={!!info} // disabled={prop === "email" && info}
                    inputType="text"
                    title={prop === "name" ? "Nombre: " : "Email: "}
                    value={localInfo[prop] || ""}
                    readOnly={!!info} // readOnly={user.role !== "SuperAdmin"}
                    onChange={(e) => onChangeSomeValue(prop, e.target.value)}
                  />
                </li>
              );
            })}

            <li key={`password-${cardId}`} className="flex flex-col">
              {/* info && (
                <div className="flex flex-row items-center gap-x-1 w-fit px-4">
                  <input
                    type="checkbox"
                    //className="w-fit"
                    checked={showEditPassword}
                    onChange={(e) => setShowEditPassword(e.target.checked)}
                  />
                  <label className="text-dark-green py-2 px-4 text-base w-fit cursor-pointer font-poppins">
                    Actualizar Contraseña
                  </label>
                </div>
              ) */}

              {showEditPassword && !info && (
                <CustomInput
                  //disabled={prop === "password" && !info}
                  inputType="password"
                  title={"Contraseña"}
                  value={password}
                  //readOnly={user.role !== "SuperAdmin"}
                  onChange={(e) => setPassword(e.target.value)}
                />
              )}
            </li>
          </ul>
        </div>
      </div>
      <div className="flex flex-wrap w-full  items-center  justify-center gap-2">
        {!info && (
          <button
            className={`${
              uploading
                ? "bg-light-gray cursor-not-allowed"
                : "hover:bg-light-purple-600 bg-dark-purple"
            } text-white rounded-full py-2 px-4 text-base font-poppins`}
            onClick={(e) => (uploading ? null : handleSubmit(e))}
          >
            {/* info ? "Actualizar" : */ "Crear"}
          </button>
        )}
        {/*info && (
          <button
            className={`${
              uploading
                ? "bg-light-gray cursor-not-allowed"
                : "hover:bg-red-300 bg-red-500"
            } text-white rounded-full py-2 px-4 text-base font-poppins`}
            onClick={(e) => {
              e.preventDefault();
              setShowDeleteModal(true);
            }}
          >
            Eliminar
          </button>
        )*/}
      </div>
      {/**Modal de confirmacion de eliminacion */}
      {showDeleteModal && (
        <ModalStructure
          customMaxW={"max-w-[300px]"}
          handleCloseModal={() => setShowDeleteModal(false)}
        >
          <div className="flex flex-col items-center justify-center gap-y-2 p-4">
            <h3 className="text-dark-green font-bold text-lg">
              ¿Estás seguro de eliminar a {info.name}?
            </h3>
            <button
              className={`${
                uploading
                  ? "bg-light-gray cursor-not-allowed"
                  : "hover:bg-red-300 bg-red-500"
              } text-white rounded-full py-2 px-4 text-base font-poppins`}
              onClick={(e) => (uploading ? null : handleDelete(e, info.id))}
            >
              Eliminar
            </button>
          </div>
        </ModalStructure>
      )}
    </div>
  );
};

export default UserCard;
